import React        from 'react'
import ImagePcbNoon from 'images/pu/products/pcb_noon.svg'

export default () => (
  <div className="usa-notes">
    <p>
      <strong>Cutoff Time (PST)</strong> 5:00 p.m. <br />
      V-score and tab route available
    </p>
  </div>
)
